<template>
  <div id="app">
    <common-carousel :carouselData="carouselData" />
    <div class="container">
      <observer @on-change="rightOnChange" :threshold="threshold">
        <div
          class="amap-page-container"
          :class="{ 'visible-bottom': visibleBottom }"
        >
          <div class="map-hint animation-10 animation-right">
            <div
              class="hint-item flex-display"
              v-for="(item, index) in hintList"
              :key="index"
            >
              <img :src="item.img" class="img" alt="" />
              <div class="text-frame flex-display flex-display-column">
                <span class="title">{{ item.title }}</span>
                <span class="details">{{ item.details }}</span>
              </div>
            </div>
          </div>

          <el-amap
            vid="amapDemo"
            :center="center"
            :zoom="zoom"
            class="amap-demo"
            :events="events"
            pitch-enable="false"
          >
            <el-amap-marker
              v-for="(marker, index) in markers"
              :key="index"
              :events="marker.events"
              :position="marker.position"
            />
            <el-amap-info-window
              v-if="window"
              :position="window.position"
              :visible="window.visible"
              :content="window.content"
              :offset="window.offset"
              :close-when-click-map="true"
              :is-custom="true"
            >
              <div id="info-window">
                <p>{{ window.address }}</p>
              </div>
            </el-amap-info-window>
          </el-amap>
        </div>
      </observer>
    </div>
  </div>
</template>

<script>
import commonCarousel from '@/components/common/carousel'
import Observer from '@/components/index.js'

export default {
  name: 'AmapPage',
  components: {
    commonCarousel, Observer

  },
  data: function () {
    const self = this
    return {
      visibleBottom: false, // 显示-向左/右动画效果
      threshold: [1], // [0, 0.25, 0.5, 0.75, 1] 1：元素百分百滑动到可见区域时
      hintList: [
        { img: `${this.$baseImgUrl}images/map-hint-1.png`, title: '公司名称', details: '广东卡百利新材料科技有限公司' },
        { img: `${this.$baseImgUrl}images/map-hint-2.png`, title: '广东省 广州市 海珠区', details: '海珠同创汇西8街44-108' },
        { img: `${this.$baseImgUrl}images/map-hint-3.png`, title: '联系电话', details: '400-830-9077' }

      ],

      carouselData: [
        {
          title: '卡百利新材料',
          subTitle: '主要帮助家居行业的品牌方，提供CRM、数字化营销、商城小程序、企业商学院产品的开发及运营',
          rightImg: `${this.$baseImgUrl}images/contactUs-slideshowRight-1.png`,
          url: `${this.$baseImgUrl}images/contactUs-slideshow-1.png`
        }
      ],
      data: [
        {
          position: '113.3161, 23.076229',
          address: '海珠区同创汇D2栋'

        }],
      zoom: 2000,
      center: [113.3161, 23.076229],
      markers: [],
      windows: [],
      window: '',
      events: {
        click (e) {
          const { lng, lat } = e.lnglat
          self.lng = lng
          self.lat = lat
        }
      },
      lng: 23.076537,
      lat: 113.316353
    }
  },
  mounted () {
    this.point()
    // 监听滚动条
  },
  methods: {

    rightOnChange (entry) {
      // 滑动到-地图
      this.visibleBottom = entry.isIntersecting
    },
    point () {
      // 初始化地图
      const markers = []
      const windows = []
      const that = this

      this.data.forEach((item, index) => {
        markers.push({
          position: item.position.split(','),
          events: {
            mouseover () {
              // 方法：鼠标移动到点标记上，显示相应窗体
              that.window = that.windows[index]
              that.$nextTick(() => {
                that.window.visible = true
              })
            },
            mouseout () {
              that.windows.forEach(window => {
                window.visible = false // 关闭窗体
              })
            }
          }
        })
        windows.push({
          position: item.position.split(','),
          isCustom: true,
          offset: [115, 55], // 窗体偏移
          showShadow: true,
          visible: true, // 初始是否显示
          address: item.address
        })
      })
      //  加点
      this.markers = markers
      // 加弹窗
      this.windows = windows
    }

  }

}
</script>

<style scoped lang="less">
.container {
  padding: 100px 0;

  box-sizing: content-box;
}

.amap-page-container {
  position: relative;
  height: 500px;
}

#info-window {
  line-height: 50px;
  padding: 0 20px;
  margin-left: 10px;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 4px;
  position: relative;
  overflow: hidden;
}
.map-hint {
  width: 240px;
  height: 298px;
  background: #ffffff;
  box-shadow: 0px 16px 16px 0px rgba(88, 118, 230, 0.1);
  border-radius: 6px;
  opacity: 0.9;
  position: absolute;
  z-index: 1;
  left: 87px;
  top: 60px;
  padding: 40px 12px 0 12px;
  .hint-item {
    .img {
      width: 64px;
      height: 64px;
    }
    .text-frame {
      height: 64px;
      flex: 1;
    }
    .title {
      background: #ffffff;

      border-radius: 6px;
      opacity: 0.9;
      margin-bottom: 4px;
    }
    .details {
      width: 180px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #323354;
      line-height: 20px;
    }
  }
  .hint-item {
    margin-bottom: 24px;
  }
  .hint-item:last-child {
    margin-bottom: 0;
  }
}

/* //  去掉地图水印 */

/deep/ .amap-logo {
  display: none !important;
  visibility: hidden !important;
  opacity: 0;
}

/deep/ .amap-copyright {
  display: none !important;
  visibility: hidden !important;
}
// 动画-右
.animation-right {
  opacity: 0;
  transform: translateX(-100px);
  transform: translateX(-100px);
  -ms-transform: translateX(-100px);
  -moz-transform: translateX(-100px);
  -webkit-transform: translateX(-100px);
  -o-transform: translateX(-100px);
}

.visible-bottom .animation-right {
  transform: translateX(0);
  transform: translateX(0);
  -ms-transform: translateX(0);
  -moz-transform: translateX(0);
  -webkit-transform: translateX(0);
  -o-transform: translateX(0);
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/pages/us/contactUs.vue